import { notification } from 'antd';
import http from 'utils/http';

export const addDeclineListEntry = async (storeId, payload, activeTab) => {
  try {
    const response = await http.post(`/public/v1/fraud/list/decline?store_id=${storeId}`, payload);
    notification?.success({ message: `${activeTab} Added`, description: `${activeTab} has been added successfully to Block List`, placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const getDeclineList = async (params) => {
  try {
    const response = await http.get(`/public/v1/fraud/list/decline`, { params });
    return response;
  } catch (err) {
    //  notification?.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};

export const deleteDeclineListArray = async (storeId, decline_list_type) => {
  try {
    const response = await http.delete(`/public/v1/fraud/list/decline/${decline_list_type}?store_id=${storeId}`);
    notification.success({
      message: `${decline_list_type} Deleted`,
      description: `${decline_list_type} has been deleted successfully.`,
      placement: 'bottomRight',
    });
    return response;
  } catch (err) {
    notification.error({
      message: err?.response?.data?.message || 'An error occurred',
      placement: 'bottomRight',
    });
  }
};

export const deleteDeclineListEntry = async (storeId, decline_list_type, value) => {
  try {
    let updatedValue = decline_list_type === 'phone_numbers' ? encodeURIComponent(value) : value;
    const response = await http.delete(`/public/v1/fraud/list/decline/${decline_list_type}?value=${updatedValue}&store_id=${storeId}`);
    notification?.success({ message: `${decline_list_type} Deleted`, description: `${value} has been deleted successfully.`, placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const getDeclineListStats = async (params) => {
  try {
    const response = await http.get(`/public/v1/fraud/engine/performance/block/list`, { params });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};

export const getSingleListDetails = async (params, decline_list_type) => {
  try {
    const response = await http.get(`/public/v1/fraud/engine/performance/block/list/${decline_list_type}`, { params });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};

export const createRule = async (storeId, payload) => {
  try {
    const response = await http.post(`/public/v1/fraud/rules?store_id=${storeId}`, payload);
    notification?.success({ message: 'New Rule Added', description: 'New Rule has been added successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const getRuleList = async (params) => {
  try {
    const response = await http.get(`/public/v1/fraud/rules`, { params });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};

export const getSingleRule = async (storeId, rule_id) => {
  try {
    const response = await http.get(`/public/v1/fraud/rules/${rule_id}?store_id=${storeId}`);
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};

export const updateRule = async (storeId, rule_id, payload) => {
  try {
    const response = await http.patch(`/public/v1/fraud/rules/${rule_id}?store_id=${storeId}`, payload);
    notification?.success({ message: 'Rule Updated', description: 'Rule information has been updated successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const deleteRule = async (storeId, rule_id) => {
  try {
    const response = await http.delete(`/public/v1/fraud/rules/${rule_id}?store_id=${storeId}`);
    notification?.success({ message: 'Rule Deleted', description: 'Rule has been deleted successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const getXShieldStats = async (params) => {
  try {
    const response = await http.get(`public/v1/fraud/engine/performance`, { params });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};

export const getRuleListStats = async (params) => {
  try {
    const response = await http.get(`/public/v1/fraud/engine/performance/rule`, { params });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};

export const getSingleRuleDetails = async (params, rule_id) => {
  try {
    const response = await http.get(`/public/v1/fraud/engine/performance/rule/${rule_id}`, { params });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};
